<template>
  <div>
      <div class="row borderBottom mb-3">
        <div class="col-8 pl-0">
        <div class="row">
            <div class="col-3">
            <div class="avatar color__white">
                <img :src="cartItem.crop.image_url" v-if="cartItem.crop.image_url" />
                <span v-else>
                    {{cartItem.crop.farm.farmer_name | initials}}
                </span>
            </div>
            </div>
            <div class="col-9">
            <h5 class=" font-bold font-md">{{cartItem.crop.name}}</h5>
            <p class="m-0 p-0">By <span class="color__primary">{{cartItem.crop.farm.farmer_name}}</span></p>
            <p class="m-0 p-0"><small class="smallFont">Price: </small> 
                <span class="font-bold font-md"><i class="naira"></i> {{perTon | formatNumber }}</span>
                <small class="smallFont"> per ton</small>
            </p>
            <p class="m-0 p-0"><small class="smallFont">Qty: </small> 
                <span class="font-bold font-md">{{cartItem.quantity / 1000}}</span> 
                <small class="smallFont"> tons</small>
            </p>
            </div>
        </div>
        </div>
        <div class="col-4 pl-0">
            <h4 class="font-md font-bold text-right"><span class="naira"></span> 
                {{amount | formatNumber }}
            </h4>
            <a href="#"
            class="color__primary font-bold text-right" 
            @click="removeItem">
                <p>Remove item</p>
            </a>
            <!-- <submit-button :loading="loading"
            class="color__primary font-bold text-right btn btn-sm btn-link" 
            @click="removeItem">
                <p>Remove item</p>
            </submit-button> -->
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    props: ['cartItem'],
    data() {
        return {
            loading: false
        }
    },
    computed: {
        perTon() {
            return this.cartItem ? this.cartItem.crop.kg_price / 0.001 : ''
        },
        amount() {
            return this.cartItem ? this.perTon * (this.cartItem.quantity / 1000) : ''
        }
    },
    methods: {
        ...mapMutations('offtaker', ['remove_item']),
        removeItem() {
            this.$http.delete(`cart_items/${this.cartItem.crop_id}`)
            .then((res) => {
                console.log('Delete ',res.data)
                this.remove_item(this.cartItem.crop_id)
                this.$toastr.success('Item removed')
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            
        },
        
    }
}
</script>

<style>

</style>